// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__1bBHg","list":"PatternAutocomplete_list__2paXb"};